// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_qj-5";
export var filledCircle = "_qj-4";
export var historyEntry = "_qj-3";
export var messageSideLeft = "_qj-1";
export var messageSideRight = "_qj-2";
export var orderTrackingCarouselWrapper = "_qj-6";
export var orderTrackingInfoContainer = "_qj-0";